"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');


var _broadcast = require('shared/selectors/broadcast');
var _user = require('shared/selectors/user');
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _hooks = require('web/services/hooks');


var _columnPrefs = require('./columnPrefs');





















const NO_FIELDS = []

/* M8: one table column per declared variable. G5: each user can reorder and
 * hide them; the choice is kept per campaign in this browser. */
const useTemplateColumns = (campaignKey) => {
  const fields = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _ => _.TemplateFields]), () => ( NO_FIELDS)))
  const template = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _2 => _2.MessageTemplate]), () => ( '')))
  const userKey = _nullishCoalesce(_hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey), () => ( 'anonymous'))
  const storageKey = _columnPrefs.columnPrefsKey.call(void 0, userKey, campaignKey)

  const [prefs, setPrefsState] = _react.useState(
    () => ({ key: storageKey, value: _columnPrefs.readColumnPrefs.call(void 0, storageKey) }),
  )
  // A different campaign or user reads its own saved prefs.
  const current = prefs.key === storageKey ? prefs.value : _columnPrefs.readColumnPrefs.call(void 0, storageKey)

  const setPrefs = _react.useCallback.call(void 0, 
    (update) => setPrefsState(p => {
      const base = p.key === storageKey ? p.value : _columnPrefs.readColumnPrefs.call(void 0, storageKey)
      const value = update(base)
      _columnPrefs.writeColumnPrefs.call(void 0, storageKey, value)
      return { key: storageKey, value }
    }),
    [storageKey],
  )

  const names = _react.useMemo.call(void 0, () => fields.map(f => f.Name), [fields])
  const order = _react.useMemo.call(void 0, () => _columnPrefs.arrangeColumns.call(void 0, names, current), [names, current])
  const hidden = _react.useMemo.call(void 0, () => new Set(current.hidden), [current])

  const columns = _react.useMemo.call(void 0, 
    () => {
      const tokens = _broadcastTemplateTokens.templateTokens.call(void 0, template)
      // A token's own fallback, then the variable's default (review R800-74).
      const defaultOf = (name) => _optionalChain([fields, 'access', _3 => _3.find, 'call', _4 => _4(f => f.Name === name), 'optionalAccess', _5 => _5.Default, 'optionalAccess', _6 => _6.trim, 'call', _7 => _7()]) || null
      return order
        .filter(name => !hidden.has(name))
        .map(name => ({
          name,
          fallback: _nullishCoalesce(_broadcastTemplateTokens.fallbackFor.call(void 0, tokens, name), () => ( defaultOf(name))),
          needsValue: _broadcastTemplateTokens.needsValue.call(void 0, tokens, name) && !defaultOf(name),
        }))
    },
    [order, hidden, template, fields],
  )

  const all = _react.useMemo.call(void 0, () => order.map(name => ({ name, isHidden: hidden.has(name) })), [order, hidden])

  const onMove = _react.useCallback.call(void 0, 
    (name, before) => setPrefs(p => ({
      ...p,
      order: _columnPrefs.moveColumn.call(void 0, _columnPrefs.arrangeColumns.call(void 0, names, p), name, before),
    })),
    [setPrefs, names],
  )
  const onSetHidden = _react.useCallback.call(void 0, 
    (name, isHidden) => setPrefs(p => ({
      ...p,
      hidden: isHidden ? [...p.hidden.filter(n => n !== name), name] : p.hidden.filter(n => n !== name),
    })),
    [setPrefs],
  )
  const onReset = _react.useCallback.call(void 0, () => setPrefs(() => ({ order: [], hidden: [] })), [setPrefs])

  return { columns, all, onMove, onSetHidden, onReset }
}

exports. default = useTemplateColumns
